import { Statistic } from "antd";
import axios from "axios";

// switch (window.location.hostname) {
//   case "localhost":
//     const baseURL = "http://localhost";
//     const v3URL = "sandbox-kase.pa-sys.com";

//     break;
//   case "endeavour.uat.pa-g.com":
//     const v3URL = "sandbox.pa-sys.com";
//     break;
//   case "endeavour.paymentasia.com":
//     const v3URL = "sandbox.pa-sys.com";
//     break;
// }

const scopes = "payplus payplus.write";
// const baseURL = "http://localhost:3001";
// const baseURL = "https://endeavour.uat.pa-g.com";
const clientID = "12ff71c9-0ba3-4ae9-a378-0400363df889";
const baseURL = "https://endeavour.payplus.com.au";
// const origin = "https://d3llrj9jceo0wb.cloudfront.net/production-payplus-management/";
const origin = "https://prod-payplus-au.pages.dev/";

// const baseURL = "http://localhost";

// const clientID = "b99fefd1-e6b0-4896-a870-35c3717f0214";
// const origin = "http://localhost:3000/";

const numberFormat = (num) => {
  return parseFloat(num)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

const ISO8601 = (time) => {
  if (/\d{10}/.test(time)) {
    time = time * 1000;
  }
  const date = new Date(time);
  const formatted = date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  return formatted;
};

const DateTime = ({ value }) => {
  const date = new Date(value * 1000);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  const hours = ("0" + date.getHours()).slice(-2);
  const minutes = ("0" + date.getMinutes()).slice(-2);
  const seconds = ("0" + date.getSeconds()).slice(-2);

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const ColoredStatistic = ({ title, value, precision = 2, prefix, suffix, props }) => {
  if (value === null || isNaN(value)) {
    return;
  }
  let color = "#ea3943";
  if (parseFloat(value) > 0) {
    color = "darkgreen";
  }
  if (prefix) {
    prefix = `${prefix}$`;
  }
  return (
    <Statistic
      title={title}
      value={value}
      prefix={prefix}
      suffix={suffix}
      precision={precision}
      style={{ textAlign: "right" }}
      valueStyle={{ color: color, textAlign: "right" }}
      {...props}
    />
  );
};

const token = localStorage.getItem("access_token");

const Curl = axios.create({
  timeout: 30000,
  baseURL: baseURL,
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
});

Curl.interceptors.request.use((config) => {
  return config;
});
Curl.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response.status === 403) {
      localStorage.setItem("access_token", "");
      window.location.href = origin;
      // authorize();
    }
    return Promise.reject(error.response.data);
  }
);

function generateCodeVerifier() {
  let codeVerifier = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < 128; i++) {
    const index = Math.floor(Math.random() * characters.length);
    codeVerifier += characters.charAt(index);
  }

  return codeVerifier;
}

function sha256(plain) {
  // returns promise ArrayBuffer
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest("SHA-256", data);
}

function base64urlencode(a) {
  var str = "";
  var bytes = new Uint8Array(a);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

async function generateCodeChallenge(v) {
  var hashed = await sha256(v);
  var base64encoded = base64urlencode(hashed);
  return base64encoded;
}

const authorize = async () => {
  const client_id = clientID;
  // const origin = origin;
  const scope = scopes;
  const state = Math.random().toString(36).slice(-10);
  const code_verifier = generateCodeVerifier();
  const code_challenge = await generateCodeChallenge(code_verifier);

  sessionStorage.setItem("code_verifier", code_verifier);
  sessionStorage.setItem("state", state);

  window.location.href = `${baseURL}/oauth2.0/authorize?response_type=code&client_id=${client_id}&redirect_uri=${origin}&state=${state}&scope=${scope}&code_challenge=${code_challenge}&code_challenge_method=S256`;
};

const authCodeGrant = async () => {
  const URLParams = new URLSearchParams(window.location.search);
  const code = URLParams.get("code");
  if (!code) {
    return;
  }
  const state = URLParams.get("state");
  if (state !== sessionStorage.getItem("state")) {
    return;
  }

  const tmp = axios.create();
  return await tmp
    .post(
      `${baseURL}/oauth2.0/token`,
      {
        grant_type: "authorization_code",
        client_id: clientID,
        scope: scopes,
        redirect_uri: origin,
        code: code,
        code_verifier: sessionStorage.getItem("code_verifier"),
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
    .then((res) => {
      console.log(res.data.payload);
      localStorage.setItem("access_token", res.data.payload.access_token);
      return true;
    })
    .catch((err) => console.log(err.response));
};

// const baseURL =
// "https://endeavour.paymentasia.com/resources/card-programs/b58ad182-f15d-42df-9231-ad634a78b0de";
// const baseURL = "https://endeavour.uat.pa-g.com/resources/card-programs/b58ad182-f15d-42df-9231-ad634a78b0de";

const authorization = {
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
};

const FloatAdd = (arg1, arg2, decimal) => {
  let r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  const result = (FloatMul(arg1, m) + FloatMul(arg2, m)) / m;
  if (decimal === undefined) {
    return result;
  }
  return Number(result.toFixed(decimal));
};

const FloatSubtraction = (arg1, arg2, decimal) => {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = r1 >= r2 ? r1 : r2;
  const result = ((arg1 * m - arg2 * m) / m).toFixed(n);
  if (decimal === undefined) {
    return result;
  }
  return Number(result.toFixed(decimal));
};

const FloatMul = (arg1, arg2, decimal) => {
  let m = 0;
  let s1 = arg1.toString();
  let s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}

  const result = (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / Math.pow(10, m);
  if (decimal === undefined) {
    return result;
  }
  return Number(result.toFixed(decimal));
};

const FloatDiv = (arg1, arg2, decimal) => {
  let t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = arg1.toString().split(".")[1].length;
  } catch (e) {}
  try {
    t2 = arg2.toString().split(".")[1].length;
  } catch (e) {}

  r1 = Number(arg1.toString().replace(".", ""));
  r2 = Number(arg2.toString().replace(".", ""));

  const result = (r1 / r2) * Math.pow(10, t2 - t1);
  if (decimal === undefined) {
    return result;
  }
  return Number(result.toFixed(decimal));
};
export {
  numberFormat,
  DateTime,
  ISO8601,
  ColoredStatistic,
  baseURL,
  authorization,
  Curl,
  authorize,
  authCodeGrant,
  FloatAdd,
  FloatDiv,
  FloatMul,
  FloatSubtraction,
};
